import Button from 'components/core/button';
import Checkbox from 'components/forms/checkbox';
import Form from 'components/forms/form';
import Input from 'components/forms/input';
import Separator from 'components/forms/separator';
import Textarea from 'components/forms/textarea';
import SpinnerLoader from 'components/system/spinner-loader';
import { useAuth } from 'hooks/useAuth';
import { useConfiguratorApi } from 'hooks/useConfiguratorApi';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import { Errors, Routes, StaticUrls } from 'utils/constants';
import * as Yup from 'yup';
import './index.scss';

function SpecialOptionOverlay (props) {
	const { specialOption } = useConfiguratorApi();
	const { i18n, t } = useTranslation('translations');
	const { user } = useAuth();
	const history = useHistory();
	const [isLoading, setIsLoading] = useState(false);
	
	const validationSchema = Yup.object({
		firstName: Yup.string().required(t(Errors.Required)),
		secondName: Yup.string().required(t(Errors.Required)),
		comment: Yup.string().required(t(Errors.Required)),
		username: Yup.string().email(t(Errors.EMail)).required(t(Errors.Required)),
		privacy: Yup.boolean().required(t(Errors.Required)).oneOf([true], t(Errors.Privacy)),
	});
	
	const handleSubmit = async (values) => {
		setIsLoading(true);
		await specialOption({ ...values, specialOptionId: props.specialOptionId });
		setIsLoading(false);
		props.onClose();
		history.push(Routes.specialOptionSuccess);
	};
	
	return (
		props.isOpen &&
		createPortal(
			<div className="special-option-overlay">
				<div className="bg"></div>
				<div className="content">
					<div className="intro-container">
						<div className="t2 title">
							<div></div>
							<div className="close-button">
								<Button
									onClick={props.onClose}
									icon="close"
									width="14"
									height="14"
								/>
							</div>
						</div>
					</div>
					<div className="content-container">
						<SimpleBar style={{ maxHeight: 'calc(100vh - 150px)' }} autoHide={false}>
							<div className="inner-content">
								<SpinnerLoader
									show={isLoading}
								/>
								<Form
									initialValues={{
										firstName: user ? user.firstName : '',
										secondName: user ? user.lastName : '',
										username: user ? user.eMail : '',
										comment: '',
										privacy: false,
									}}
									validationSchema={validationSchema}
									onSubmit={handleSubmit}
								>
									<Separator text="SpecialOption_Headline2" />
									<Input name="firstName" text="Form_Firstname" type="text" />
									<Input name="secondName" text="Form_Lastname" type="text" />
									<Input name="username" text="Form_EmailLong" type="text" />
									<Textarea
										name="comment"
										placeholder={t('Form_Comment')}
									/>
									<Checkbox
										name="privacy"
										id="privacy"
										text="SpecialOption_PrivacyText"
										textLink={StaticUrls('privacy2', '', i18n.language)}
									/>
									<Button
										class="btn-primary"
										type="submit"
										text="SpecialOption_Send"
									/>
								</Form>
							</div>
						</SimpleBar>
					</div>
				</div>
			</div>,
		  document.body
		)
	);
}

export default SpecialOptionOverlay;
